'use client';

import type { FC, ImgHTMLAttributes } from 'react';
import type { LayoutSlice } from '@/types/zones/zone';
import { classes } from '@/utils/classes/classes';

import './styles/default.scss';

const landscape_img = {
    srcSet: ['auto=format&h=415 936w', 'auto=format&h=458 1404w', 'auto=format&h=524 1478w', 'auto=format&h=579 1960w'],
    sizes: '(max-width: 1200px) 100vw, (max-width: 1400px) 1404px, (max-width: 1478px) 1478px, 1960px'
};

const portrait_img = {
    srcSet: ['auto=format&w=390 390w', 'auto=format&w=585 585w', 'auto=format&w=780 780w', 'auto=format&w=1170 1170w'],
    sizes: '(max-width: 480px) 390px, (max-width: 768px) 585px, (max-width: 1024px) 780px, 1170px'
};

const getImageProps = (isLandscape: boolean, url: string): ImgHTMLAttributes<HTMLImageElement> => {
    const srcSet = (isLandscape ? landscape_img.srcSet : portrait_img.srcSet).map((el) => `${url}&${el}`).join(', ');

    return {
        fetchPriority: 'high',
        src: `${url}&auto=format&h=415`,
        srcSet,
        sizes: isLandscape ? landscape_img.sizes : portrait_img.sizes,
        alt: 'Exclusive Game Background',
        loading: 'eager'
    };
};

type BackgroundProps = {
    layoutContent: LayoutSlice;
    isLandscape: boolean;
};

export const ExclusivePostLaunchBackground: FC<BackgroundProps> = ({ layoutContent, isLandscape }) => {
    const url = layoutContent?.primary?.background?.url || '';
    const orientationClass = isLandscape ? 'landscape' : 'portrait';

    return (
        <div className={classes('exclusive-post-launch-background', orientationClass)}>
            <img {...getImageProps(isLandscape, url)} alt="portraitBackground" />
        </div>
    );
};
